<template>
  <div class="layout-wrapper responsive-x-padding">
    <v-app-bar
      app
      flat
      :style="{ background: theme.appBarBg, color: theme.appBarColor }"
      elevation="0"
      class="responsive-x-padding"
      style="width: 100%;"
    >
      <!-- Logo -->
      <router-link :to="{ name: 'PublicHome' }">
        <v-img
          v-if="getCurrentTheme === 'light'"
          :src="getLogoLight"
          style="width: 200px; height: 42px;"
        />
        <v-img
          v-else
          :src="getLogoDark"
          style="width: 200px; height: 42px;"
        />
      </router-link>

      <v-divider vertical></v-divider>

      <!-- <v-label class="d-none d-md-flex" style="margin-left: 10px;">
        NB-Simple Accounting
      </v-label> -->

      <!-- <MegaMenu />

      <v-btn link :to="{name: 'CreateAccount'}">
        Create Clinic
      </v-btn> -->

      <v-spacer />
      <v-spacer />
      <v-spacer />
      <v-spacer />

      <span class="d-none d-md-flex">
        <VuetifySearch />
      </span>

      <v-spacer />

      <v-divider vertical class="mx-3"></v-divider>

      <div class="d-flex align-center">
      
      <v-menu v-model="toprightmenu" :close-on-content-click="false">
        <template #activator="{ props }">
          <span
            v-bind="props"
            v-ripple
            class="icon-btn d-inline-flex align-center justify-center"
            style="margin-right: 10px;"
          >
            <v-tooltip :text="t('themeswitch')" style="z-index: 9999999999999;" location="bottom">
              <template v-slot:activator="{ props }">
                <v-icon  v-bind="props" size="small" :style="{color: theme.appBarColor}">mdi-theme-light-dark</v-icon>
              </template>
            </v-tooltip>
          </span>
        </template>

        <v-card min-width="300" :style="{ background: theme.appBarBg, color: theme.appBarColor }">
          <v-list>
            <v-list-item
              prepend-avatar="https://cdn.vuetifyjs.com/images/john.jpg"
              subtitle="Founder of Vuetify"
              title="John Leider"
            >
              <template #append>
                <v-btn
                  icon="mdi-logout-variant"
                  variant="text"
                  @click="handleLogout"
                >{{t('logout')}}</v-btn>
              </template>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

        
          <v-row class="ma-2">
            <v-col cols="4" class="text-center">
              <v-switch
                v-model="lightSwitch"
                color="purple"
                hide-details
                @change="selectTheme('light')"
              />
              <div>{{ t('nbthemecardtitletext7')}}</div>
            </v-col>

            <v-col cols="4" class="text-center">
              <v-switch
                v-model="darkSwitch"
                color="purple"
                hide-details
                @change="selectTheme('dark')"
              />
              <div>{{t('nbthemecardtitletext8')}}</div>
            </v-col>

            <v-col cols="4" class="text-center">
              <v-switch
                v-model="hybridSwitch"
                color="purple"
                hide-details
                @change="selectTheme('hybrid')"
              />
              <div>{{ t('nbthemecardtitletext9')}}</div>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-list>
            <v-list-item>
              <v-switch
                v-model="message"
                color="purple"
                :label="t('NBTD00000010')"
                hide-details
              />
            </v-list-item>

            <v-list-item>
              <v-switch
                v-model="hints"
                color="purple"
                :label="t('NBTD00000011')"
                hide-details
              />
            </v-list-item>
          </v-list>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="toprightmenu = false" :style="{bacground: theme.BtnBgColor, color: theme.BtnColor }">
              {{ t('nbcancel')}}
            </v-btn>
            <v-btn color="primary" variant="text" @click="toprightmenu = false" :style="{bacground: theme.BtnBgColor, color: theme.BtnColor }">
              {{ t('NBTDB000000003')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
         
          <!-- Language Menu -->
          <v-menu v-model="toprightmenu1" offset-y  :style="{background: appBarBg, color: theme.appBarColor}">
            <template #activator="{ props }">
              <span
                v-bind="props"
                class="formatlang"
                style="
                  display: inline-flex;
                  align-items: center;
                  cursor: pointer;
                  gap: 2px;
                "
               
              >
                <v-tooltip activator="parent" location="bottom" :style="{color: theme.appBarColor}">
                 {{ t('langswitch' )}}
                </v-tooltip>
                <LanguageSwitcher @change="onLanguageChange" />
              </span>
            </template>
          </v-menu>
        </div>
    </v-app-bar>

    <NbFooter />
  </div>
</template>

<script setup>
import LanguageSwitcher from "@/components/LanguageSwitcher.vue"
import { ref, nextTick, computed, onMounted, watch  } from "vue"
import { useRouter } from "vue-router"
import { useLangStore } from '@/store/lang'
import { useThemeStore, useAuthStore, } from "@/store/auth"
import { useI18n } from 'vue-i18n'
import publicApi from "@/auth/publicApi"
const { t, locale } = useI18n()
const lang = useLangStore()
const themeStore = useThemeStore()
const theme = computed(() => themeStore.themeStyles)
const auth = useAuthStore()

watch(
  () => lang.currentLanguage,
  (newLang) => { locale.value = newLang },
  { immediate: true }
)

const router = useRouter()

// SETTINGS / THEMES
const toprightmenu = ref(false)
const toprightmenu1 = ref(false)

const message = ref(false)
const hints = ref(false)

const lightSwitch = ref(false)
const darkSwitch = ref(false)
const hybridSwitch = ref(false)

function selectTheme(theme) {
  lightSwitch.value = theme === "light"
  darkSwitch.value = theme === "dark"
  hybridSwitch.value = theme === "hybrid"
  themeStore.setTheme(theme)
}

const langStore = useLangStore();



const getLogoLight = ref('')
const getLogoDark = ref('')
const getCurrentTheme = ref('')
const isUserLogin = ref('')

const logoTarget = computed(() => {
  const lang = langStore.currentLang || "en";
  return auth.isLogin
    ? { name: "UserDashboard", params: { lang } }
    : { name: "PublicHome", params: { lang } };
});

function handleLogout() {
  auth.logout()
}


function onLanguageChange(lang) {
  locale.value = lang
  nextTick(() => {
    console.log('Language updated, DOM updated safely')
  })
}

// ------------------
// Global ResizeObserver suppression
// ------------------
const originalOnError = window.onerror;

window.onerror = function (msg, src, line, col, err) {
  if (typeof msg === 'string' && msg.includes('ResizeObserver loop')) {
    console.warn('ResizeObserver loop suppressed');
    return true; // stops Webpack overlay sdfsfsdf
  }

  if (originalOnError) return originalOnError(msg, src, line, col, err);
};



onMounted(async () => {
  // await tenantStore.loadTenant()
 

  getLogoLight.value = localStorage.getItem('LogoLight')
  getLogoDark.value = localStorage.getItem('LogoDark')
  getCurrentTheme.value = localStorage.getItem('currentTheme')

  isUserLogin.value = localStorage.getItem('isLogin')
})

</script>

<style scoped>
.responsive-x-padding {
  padding-left: 10px;
  padding-right: 10px;
}
.icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.icon-btn:hover {
  background-color: rgba(0, 0, 0, 0.08);
}
@media (min-width: 600px) {
  .responsive-x-padding {
    padding-left: 10px;
    padding-right: 10px;
  }
}

@media (min-width: 960px) {
  .responsive-x-padding {
    padding-left: 100px;
    padding-right: 100px;
  }
}

@media (min-width: 1920px) {
  .responsive-x-padding {
    padding-left: 300px;
    padding-right: 300px;
  }
}
</style>